/** Mínimo de elementos de `page_contents` para considerar el modo mosaico
 * (FR-007) — por debajo, y por encima de 1 (modo banner), se oculta. */
export const MIN_GALLERY_ITEMS = 3

/** Con exactamente 2 elementos, el mosaico se muestra igualmente si al menos
 * uno de ellos aporta un vídeo válido (FR-007). */
export const MIN_GALLERY_ITEMS_WITH_VIDEO = 2

/** Etiqueta accesible del mosaico paginado. */
export const CAROUSEL_SECTION_LABEL = 'Galería multimedia'
